import React from 'react'
import { Dialog, Button, CardContent, Typography, Box } from '@material-ui/core'

const WaitingDialog = ({ open, close, requestUser }) => {
  return (
    <Dialog open={open} disableBackdropClick>
      <CardContent>
        <Typography>
          Waiting on the current livestream to grant you streaming access.
        </Typography>
      </CardContent>
      <Box
        display="flex"
        style={{ marginBottom: '16px' }}
        justifyContent="center"
      >
        <Button variant="contained" onClick={() => close(false)}>
          Cancel Stream Request
        </Button>
      </Box>
    </Dialog>
  )
}

export default WaitingDialog



// WEBPACK FOOTER //
// ./src/pages/Stream/waitingDialog.jsx